export const VERSION = "v1";
export const API_URL = `${process.env.REACT_APP_BASE_PATH}/api/${VERSION}/`;
export const SERVER_IMAGE_API_URL = `${process.env.REACT_APP_BASE_PATH}/admin/public/uploads/`;
export const IMAGE_API_URL = `${process.env.REACT_APP_BASE_PATH}/admin/public/games/`;
export const AVATAR_IMAGE_URL = `${process.env.REACT_APP_BASE_PATH}/admin/public/avtar/`;
export const BADGES_IMAGE_URL = `${process.env.REACT_APP_BASE_PATH}/admin/public/badges/`;

//Routes
export const LOGIN = `login`;
export const REGISTER = `register`;
export const VERIFYOTP = `verify-otp`;
export const FORGOTPASSWORD = `forgotpassword`;
export const HOME ='home';
export const ONBOARDING ='onboarding';
export const BMICALCULATOR = "bmicalculator";
export const TARGETRESULT ='targetresult';
export const TRAILASSESMENT ='trailassessment';
export const CREATEPROFILE ='createprofile';
export const GAME ='game';
export const GAMEPASS ='gamepass';
export const FEEDS ='feeds';
export const PROFILE ='profile';
export const DETAILED ='detailed';
export const SETTING ='setting';
export const BUDDYTOURNAMENTCREATE ='buddytournamentcreate';
export const BUDDYTOURNAMENTJOIN ='buddytournamentjoin';
export const VOICECHAT ='voicechat';
export const VERSUS ='versus';
export const TOURNAMENT ='tournament';
export const ACHIEVEMENT ='achievement';
export const DAILYTARGET ='dailytarget';
export const ACCOUNT ='account';
export const PAYMENTSUCCESS ='paymentSuccess';
export const REAL_BADGE ='realBadge';
export const MEMBERSHIP ='membership';
export const PIGGYBANK ='piggyBank';
export const CONTACT_US ='contact-us';
export const LEADERBOARD = 'leaderboard';


//API Endpoints
export const LOGINUSER = `auth/login`;
export const LOGINWITHSOCIAL = `auth/loginwithsocial`;
export const SIGNUP = `auth/signup`;
export const VERIFYUSER = `auth/activateAccount`;
export const FORGOTPASSWORDAPI = `auth/forgotpassword`;
export const RESETPASSWORDAPI = `auth/resetpassword`;
export const RESENDOTP = `auth/resendOtp`;
export const GETUSERINFO = `user`;
export const LOGOUT = `auth/logout`;
export const DELETE = `auth/delete`;
export const CALCBMI = `user/calculateBMI`;
export const ADDTRAILASSESMENTDATA = `user/trialAssesment`;
export const BMIINFOAVERAGE ='bmiInfo/getAverage';
export const BMIPROGRESSION = 'bmiInfo/progression';
export const BUDDYGAME = 'buddygame';
export const BUDDYGAMEBYID = 'buddygame/';
export const BUDDYGAMEJOIN = 'buddygame/join';
export const BUDDYGAMEUPDATE = 'buddygame/update';
export const BUDDYGAMEUPDATESTATUS = 'buddygame/updatestatus';
export const BUDDYGAMEUPDATESCORE = 'buddygame/updatescore';
export const VERSUSFINDPLAYER = 'versusgame/findPlayer';
export const VERSUSCANCEL = 'versusgame/cancel';
export const VERSUSSCOREUPDATE = 'versusgame/update';
export const GETVERSESGAME = `versusgame/game/`;
export const GETGAMES ='settings/games';
export const GET_BADGES ='settings/badges';
export const GET_MEMBERSHIP_DATA ='settings/membershipData';
export const GET_SETTINGS_DATA ='settings/data';
export const UPDATEUSER = `user/update`;
export const UPDATEUSERDETAIL = `user/updatedetail`;
export const GET_USER_GAMES = `user/games`;
export const GAMEUSER = `user/gameUsers`;
export const USERSTATUS = `auth/status`;
export const GETTRIALINFO = `settings/trialinfo`;
export const UPDATEAVTAR = `user/updateAvtar/`;
export const GET_DAILY_BMI_DATA = `bmiInfo/get/`;
export const GET_DAILY_REPORT_DATA = `report/bmidata/`;
export const GETLEVELREPORT = `report/levelProgress/`;
export const GAMEUPDATESTATUS = `game/updateStatus/`;
export const GAMEUPDATESCORE = `game/updateScore/`;
export const GETTOURNAMENT = `tournaments/filter/`;
export const GETTOURNAMENTBYID = `tournaments/tornament/`;
export const GETTOURNAMENTUSERBYID = `tournaments/leadeboard/`;
export const TOURNAMENTJOIN = `tournaments/join/`;
export const TOURNAMENTUPDATE = `tournaments/update/`;
export const GET_USER_BADGES = `achievementBadges`;
export const CLAIM_BADGE = `achievementBadges/claimBadge`;
export const GET_USER_ACCOUNT_HISTORIES = `transactions/userAccountHistories`;
export const WITHDRAWREQUEST = `transactions/withdrawAmountRequest`;
export const PAYMENTINTENT = `transactions/paymentIntent`;
export const UPDATEPAYMENTINTENT = `transactions/paymentIntentUpdate`;
export const JOINCONTESTWALLET = `transactions/joinContestWallet`;
export const CHECKOUT = `transactions/checkout`;
export const AMOUNTDEPOSITREQUEST = `transactions/amountDepositRequest`;
export const FITBITAUTH = `syncApps/syncFitbit`; 
export const FITBITDATA = `syncApps/syncFitbitdata`;
export const CREATE_GAME_SESSION = `gameSession/create`;
export const GET_SESSION_HISTORY = `gameSession/history/`;
export const ALL_SESSION_HISTORY = `gameSession/all`;
export const CLOSE_SESSION = `gameSession/complete/`;
export const GETMONTHLYLEADERBOARD = `monthlyLeaderboard`;
export const GETMONTHLYLEADERBOARDLIST = `monthlyLeaderboard/list`;
export const UPDATEMONTHLYLEADERBOARD = `monthlyLeaderboard/update`;
export const GET_USER_RANK_BY_MONTH = `monthlyLeaderboard/getUserRankByMonth`;

export const USE_STREAK_SAVER = `user/userStreakSaver`;
export const PURCHASE_MEMBERSHIP = `user/membershipPurchase`;
export const PIGGY_BANK_STATUS = `piggyBank/piggyBankStatus`;
export const OPEN_PIGGY_BANK = `piggyBank/openPiggyBank`;
export const GET_MUVER_REWARD = `user/get-muver-reward`;

export const PRODUCT_IDS = {
  PIGGY_BANK : "com.fitx.piggybanksmash",
  MONTHLY_SUBSCRIPTION : "com.fitx.subsciptiononemonth",
  YEARLY_SUBSCRIPTION : "com.fitx.subsciptiononeyear"
};

export const ALL_COUNTRIES = {
  "AF" : "Afghanistan",
  "AL" : "Albania",
  "DZ" : "Algeria",
  "AD" : "Andorra",
  "AO" : "Angola",
  "AG" : "Antigua and Barbuda",
  "AR" : "Argentina",
  "AM" : "Armenia",
  "AU" : "Australia",
  "AT" : "Austria",
  "AZ" : "Azerbaijan",
  "BS" : "Bahamas",
  "BH" : "Bahrain",
  "BD" : "Bangladesh",
  "BB" : "Barbados",
  "BY" : "Belarus",
  "BE" : "Belgium",
  "BZ" : "Belize",
  "BJ" : "Benin",
  "BT" : "Bhutan",
  "BO" : "Bolivia",
  "BA" : "Bosnia and Herzegovina",
  "BW" : "Botswana",
  "BR" : "Brazil",
  "BN" : "Brunei",
  "BG" : "Bulgaria",
  "BF" : "Burkina Faso",
  "BI" : "Burundi",
  "CV" : "Cabo Verde",
  "KH" : "Cambodia",
  "CM" : "Cameroon",
  "CA" : "Canada",
  "CF" : "Central African Republic",
  "TD" : "Chad",
  "CL" : "Chile",
  "CN" : "China",
  "CO" : "Colombia",
  "KM" : "Comoros",
  "CG" : "Congo",
  "CD" : "Congo (Democratic Republic)",
  "CR" : "Costa Rica",
  "CI" : "Côte d'Ivoire",
  "HR" : "Croatia",
  "CU" : "Cuba",
  "CY" : "Cyprus",
  "CZ" : "Czech Republic",
  "DK" : "Denmark",
  "DJ" : "Djibouti",
  "DM" : "Dominica",
  "DO" : "Dominican Republic",
  "EC" : "Ecuador",
  "EG" : "Egypt",
  "SV" : "El Salvador",
  "GQ" : "Equatorial Guinea",
  "ER" : "Eritrea",
  "EE" : "Estonia",
  "SZ" : "Eswatini",
  "ET" : "Ethiopia",
  "FJ" : "Fiji",
  "FI" : "Finland",
  "FR" : "France",
  "GA" : "Gabon",
  "GM" : "Gambia",
  "GE" : "Georgia",
  "DE" : "Germany",
  "GH" : "Ghana",
  "GR" : "Greece",
  "GD" : "Grenada",
  "GT" : "Guatemala",
  "GN" : "Guinea",
  "GW" : "Guinea-Bissau",
  "GY" : "Guyana",
  "HT" : "Haiti",
  "HN" : "Honduras",
  "HU" : "Hungary",
  "IS" : "Iceland",
  "IN" : "India",
  "ID" : "Indonesia",
  "IR" : "Iran",
  "IQ" : "Iraq",
  "IE" : "Ireland",
  "IL" : "Israel",
  "IT" : "Italy",
  "JM" : "Jamaica",
  "JP" : "Japan",
  "JO" : "Jordan",
  "KZ" : "Kazakhstan",
  "KE" : "Kenya",
  "KI" : "Kiribati",
  "KP" : "North Korea",
  "KR" : "South Korea",
  "KW" : "Kuwait",
  "KG" : "Kyrgyzstan",
  "LA" : "Laos",
  "LV" : "Latvia",
  "LB" : "Lebanon",
  "LS" : "Lesotho",
  "LR" : "Liberia",
  "LY" : "Libya",
  "LI" : "Liechtenstein",
  "LT" : "Lithuania",
  "LU" : "Luxembourg",
  "MG" : "Madagascar",
  "MW" : "Malawi",
  "MY" : "Malaysia",
  "MV" : "Maldives",
  "ML" : "Mali",
  "MT" : "Malta",
  "MH" : "Marshall Islands",
  "MR" : "Mauritania",
  "MU" : "Mauritius",
  "MX" : "Mexico",
  "FM" : "Micronesia",
  "MD" : "Moldova",
  "MC" : "Monaco",
  "MN" : "Mongolia",
  "ME" : "Montenegro",
  "MA" : "Morocco",
  "MZ" : "Mozambique",
  "MM" : "Myanmar",
  "NA" : "Namibia",
  "NR" : "Nauru",
  "NP" : "Nepal",
  "NL" : "Netherlands",
  "NZ" : "New Zealand",
  "NI" : "Nicaragua",
  "NE" : "Niger",
  "NG" : "Nigeria",
  "MK" : "North Macedonia",
  "NO" : "Norway",
  "OM" : "Oman",
  "PK" : "Pakistan",
  "PW" : "Palau",
  "PS" : "Palestine",
  "PA" : "Panama",
  "PG" : "Papua New Guinea",
  "PY" : "Paraguay",
  "PE" : "Peru",
  "PH" : "Philippines",
  "PL" : "Poland",
  "PT" : "Portugal",
  "QA" : "Qatar",
  "RO" : "Romania",
  "RU" : "Russia",
  "RW" : "Rwanda",
  "KN" : "Saint Kitts and Nevis",
  "LC" : "Saint Lucia",
  "VC" : "Saint Vincent and the Grenadines",
  "WS" : "Samoa",
  "SM" : "San Marino",
  "ST" : "Sao Tome and Principe",
  "SA" : "Saudi Arabia",
  "SN" : "Senegal",
  "RS" : "Serbia",
  "SC" : "Seychelles",
  "SL" : "Sierra Leone",
  "SG" : "Singapore",
  "SK" : "Slovakia",
  "SI" : "Slovenia",
  "SB" : "Solomon Islands",
  "SO" : "Somalia",
  "ZA" : "South Africa",
  "SS" : "South Sudan",
  "ES" : "Spain",
  "LK" : "Sri Lanka",
  "SD" : "Sudan",
  "SR" : "Suriname",
  "SE" : "Sweden",
  "CH" : "Switzerland",
  "SY" : "Syria",
  "TJ" : "Tajikistan",
  "TZ" : "Tanzania",
  "TH" : "Thailand",
  "TL" : "Timor-Leste",
  "TG" : "Togo",
  "TO" : "Tonga",
  "TT" : "Trinidad and Tobago",
  "TN" : "Tunisia",
  "TR" : "Turkey",
  "TM" : "Turkmenistan",
  "TV" : "Tuvalu",
  "UG" : "Uganda",
  "UA" : "Ukraine",
  "AE" : "United Arab Emirates",
  "GB" : "United Kingdom",
  "US" : "United States",
  "UY" : "Uruguay",
  "UZ" : "Uzbekistan",
  "VU" : "Vanuatu",
  "VA" : "Vatican City",
  "VE" : "Venezuela",
  "VN" : "Vietnam",
  "YE" : "Yemen",
  "ZM" : "Zambia",
  "ZW" : "Zimbabwe",
};